import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import ContextMenuItem from './ContextMenuItem';
import './ContextMenu.css';

const isInsideContainer = (target, container) => {
  while (target !== document.body) {
    if (target === container) return true;
    target = target.parentNode;
  }
  return false;
};

class ContextMenu extends PureComponent {
  _ctxMenuContainer = null;

  componentDidMount() {
    const { position, items } = this.props;
    const { x, y } = position;
    this._ctxMenuContainer = document.createElement('div');
    this._ctxMenuContainer.classList.add('context-menu-container');

    if (x + 200 > window.innerWidth) {
      this._ctxMenuContainer.style.left = `${x - (x + 200 - window.innerWidth)}px`;
    } else {
      this._ctxMenuContainer.style.left = `${x}px`;
    }

    let subMenuLeftPosition = '100%';
    const hasSubMenus = items.filter((i) => i.options && i.options.length > 0).length !== 0;
    if (hasSubMenus && x + 400 > window.innerWidth) {
      subMenuLeftPosition = '-100%';
    }

    const menuItemHeightPx = 42;
    const containerHeight = items.length * menuItemHeightPx;

    if (y + containerHeight > window.innerHeight) {
      this._ctxMenuContainer.style.top = `${y - (y + containerHeight - window.innerHeight)}px`;
    } else {
      this._ctxMenuContainer.style.top = `${y}px`;
    }

    document.body.appendChild(this._ctxMenuContainer);
    document.body.addEventListener('mousedown', this._hideContextMenu);

    const menuItems = items.map((item) => (
      <ContextMenuItem key={`menu-item-${item.value}`} item={item} onSelectItem={this._selectItem} subMenuLeftPosition={subMenuLeftPosition} />
    ));
    ReactDOM.render(<div className='context-menu-items-container'>{menuItems}</div>, this._ctxMenuContainer);
  }

  _selectItem = (e, item, subItem) => {
    e.stopPropagation();
    const { onItemSelected } = this.props;
    this._removeMenu();
    onItemSelected && onItemSelected(item, subItem);
  };

  _removeMenu = () => {
    const { onClose } = this.props;
    document.body.removeChild(this._ctxMenuContainer);
    document.body.removeEventListener('mousedown', this._hideContextMenu);
    onClose && onClose();
  };

  _hideContextMenu = (e) => {
    if (isInsideContainer(e.target, this._ctxMenuContainer)) return;
    this._removeMenu();
  };

  render() {
    return null;
  }
}

export default ContextMenu;
